import { compose, branch, renderNothing, withProps } from 'recompose'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { mapValues } from 'lodash'
import {
  selectIncome,
  selectDebt,
  selectDownPayment,
  selectLoanTermOrDefault,
  selectModalMethod,
  selectCalcValidity
} from 'src/store/selectors/affordability'
import { setAffordabilityValues } from 'src/actions'
import { CALCULATOR } from 'src/constants/affordability'

const CalculatePricePointTabContainer = compose(
  connect(
    state => {
      const inputs = mapValues(
        {
          income: selectIncome(state),
          debt: selectDebt(state),
          downPayment: selectDownPayment(state),
          loanTerm: selectLoanTermOrDefault(state)
        },
        v => {
          const i = parseInt(v, 10)
          return Number.isNaN(i) ? '' : v
        }
      )

      return {
        show: selectModalMethod(state) === CALCULATOR,
        valid: selectCalcValidity(state),
        ...inputs
      }
    },
    dispatch => ({
      updateValue: (name, value) => {
        dispatch(
          setAffordabilityValues({
            [name]: value
          })
        )
      }
    })
  ),
  branch(({ show }) => !show, renderNothing),
  withProps(({ updateValue }) => ({
    onChange: ({ target: { name } }, value) => updateValue(name, value)
  })),
  injectIntl
)

export default CalculatePricePointTabContainer
